import '@mockup/func/globals/App.util';

export const tableExpander2 = {
    applyZebraStriping(table) {
        const visibleRows = Array.from(table.querySelectorAll('tbody tr'))
            .filter(row => row.offsetParent !== null);
        visibleRows.forEach((row, index) => {
            row.classList.remove('is-odd', 'is-even');
            row.classList.add(index % 2 === 0 ? 'is-odd' : 'is-even');
        });
    },

    init() {
        document.querySelectorAll('table.table').forEach(table => {
            const expanderButtons = table.querySelectorAll('.expander');

            if (expanderButtons.length === 0) {
                this.applyZebraStriping(table);
                return;
            }

            expanderButtons.forEach(button => {
                button.setAttribute('aria-expanded', 'false');

                button.addEventListener('click', () => {
                    const doExpand = button.getAttribute('aria-expanded') !== 'true';

                    if (doExpand) {
                        button.classList.add('open');
                    } else {
                        button.classList.remove('open');
                    }
                    button.setAttribute('aria-expanded', doExpand);

                    const targetId = button.getAttribute('aria-controls');
                    if (targetId) {
                        const target = document.getElementById(targetId);
                        if (target) {
                            if (doExpand) {
                                target.removeAttribute('hidden');
                            } else {
                                target.setAttribute('hidden', '');
                            }
                        }
                    }
                });
            });

            this.applyZebraStriping(table);
        });
    }
};

App.Util.tableExpander2 = tableExpander2;

export default tableExpander2;

